import { applyDefaultDateRange } from '@/features/shared/models'
import { safeFormatISO } from '@/libs/utils'

import {
  hasCreatedAtRange,
  type ShipmentOrdersSearch
} from './shipment-orders-search'

/** 配送依頼一覧の既定の検索条件。呼び出すたびに日付を初期化する */
export const getDefaultSearch = (): ShipmentOrdersSearch => ({
  shippingDateFrom: safeFormatISO(new Date()),
  shippingDateTo: safeFormatISO(new Date())
})

/**
 * URL の検索条件に初回表示用の既定レンジを補った「実際に検索する条件」を返す（#5285 §4.2-9）。
 *
 * 登録日が指定されている URL（共有リンク・手組み）では既定の発送日を補わない。補うと
 * 今日の発送日が AND されて、該当データがあっても 0 件になる（#4809 と同じ形）。
 * ガードを共有ヘルパー applyDefaultDateRange 側に置かないのは、同ヘルパーを運行実績一覧も
 * 使っており、配送依頼固有の createdAtFrom/To を型引数に足すと他一覧へ波及するため。
 */
export const resolveEffectiveSearch = (
  search: ShipmentOrdersSearch
): ShipmentOrdersSearch =>
  hasCreatedAtRange(search)
    ? search
    : applyDefaultDateRange(getDefaultSearch(), search)
